import { motion } from "framer-motion";
import { Plane, TrainFront, MapPin } from "lucide-react";

const options = [
  {
    icon: Plane,
    kicker: "En avión · Recomendado",
    title: "Aeropuerto de Granada (GRX)",
    detail:
      "El aeropuerto más cercano al lugar de la celebración. Aunque tiene menos conexiones internacionales, suele ser la opción más cómoda si encontráis disponibilidad. Si no hay vuelos directos desde vuestra ciudad, podéis hacer escala en Madrid y continuar hasta Granada.",
  },
  {
    icon: TrainFront,
    kicker: "Vía Madrid",
    title: "AVE a Granada",
    detail:
      "Si llegáis a España a través de Madrid, también podéis continuar vuestro viaje en AVE hasta Granada. El trayecto dura aproximadamente 3 horas y es una excelente alternativa si no encontráis vuelos directos a Granada.",
  },
  {
    icon: Plane,
    kicker: "En avión",
    title: "Aeropuerto de Málaga (AGP)",
    detail:
      "Otra buena opción para quienes encuentran mejores conexiones a Málaga. Desde allí podéis alquilar un coche o tomar un autobús hasta Granada para continuar vuestro viaje.",
  },
];

const TravelStay = () => {
  return (
    <section
      id="travel"
      data-testid="travel-section"
      className="border-t border-[#c9c3b3] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex items-start justify-between">
          <p className="corner-label text-[#8a8580]">(01) — Cómo llegar</p>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-6 md:gap-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="col-span-12 md:col-span-7"
          >
            <h2 className="display-xl">
              Cómo
              <br />
              llegar.
            </h2>
          </motion.div>
          <div className="col-span-12 md:col-span-5 md:pt-8">
            <p className="body-lead max-w-md">
              El Cortijo de Enmedio es un cortijo andaluz de principios del
              siglo XIX, situado en la Vega de Granada — un precioso entorno
              rural a las puertas de la ciudad de Granada.
            </p>
          </div>
        </div>

        {/* Travel options */}
        <div className="mt-16 grid grid-cols-1 border-t border-[#c9c3b3] md:grid-cols-3">
          {options.map((o, i) => {
            const Icon = o.icon;
            return (
              <motion.article
                key={o.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, delay: i * 0.08 }}
                data-testid={`travel-card-${i}`}
                className={`flex flex-col gap-4 border-b border-[#c9c3b3] py-12 md:py-14 ${
                  i > 0 ? "md:border-l md:pl-10" : ""
                } md:pr-8`}
              >
                <div className="flex items-center justify-between">
                  <Icon strokeWidth={1.25} className="h-6 w-6 text-[#0a0a0a]" />
                  <span className="corner-label text-[#8a8580]">0{i + 1}</span>
                </div>
                <p className="corner-label text-[#8a8580]">{o.kicker}</p>
                <h3 className="display-md">{o.title}</h3>
                <p className="body-lead">{o.detail}</p>
              </motion.article>
            );
          })}
        </div>

        {/* Map button + future bus transfer slot */}
        <div className="mt-16 grid grid-cols-12 items-end gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-8">
            <a
              href="https://maps.google.com/?q=Cortijo+de+Enmedio+Carr.+de+la+Zubia+103D+18006+Granada"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="location-map-link"
              className="btn-base btn-outline group"
            >
              <MapPin strokeWidth={1.5} className="h-4 w-4" />
              <span>Ver el Cortijo en Google Maps</span>
              <span className="transition-transform duration-500 group-hover:translate-x-1">→</span>
            </a>
          </div>

          {/* Taxi / transport info */}
          <div className="col-span-12 md:col-span-4 md:text-right">
            <p className="corner-label text-[#8a8580]">¿Necesitas taxi en Granada?</p>
            <a
              href="tel:+34958280000"
              data-testid="taxi-link"
              className="mt-1 block corner-label nav-underline md:inline-block"
            >
              PideTaxi Granada · +34 958 28 00 00
            </a>
            <p className="mt-2 corner-label text-[#8a8580]">
              También funciona Uber en la ciudad.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TravelStay;
